import { render } from "./MonthlyProfitsCard.vue?vue&type=template&id=c1ba46c8"
import script from "./MonthlyProfitsCard.vue?vue&type=script&lang=js"
export * from "./MonthlyProfitsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__